import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizContainer } = framework_tool
const { isType } = utils_tool
import {WizInputNumber} from "wiz-components";
let {WizForm, WizRow,WizCol, WizIcon, WizTooltip } = component_tool;
class Editor extends WizContainer {
  componentName = 'Editor'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime()
    }
  }

  _ok = (data) => {
    let fitterValues = this.fitterFieldsValue(data);
    this.doAction({
      path: 'interactLiveResources/batchCreateZoomUserResources',
      payload: {
        key: 'interactLiveResources@batchCreateZoomUserResources',
        apiParams: {...fitterValues}
      }
    })
  }


  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(data) {
    let fitterValues = {};
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (key === 'expirationTime' && value != null && value != undefined) {
        fitterValues['expirationTime'] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  propsAndStateOnChange = {
    save: this._saveOnChange.bind(this)
  }

  _saveOnChange(nextProps, nextState) {
    if (nextProps.save.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false, true);
      let { editorSuccess } = this.props
      editorSuccess && editorSuccess()
    } else {
      wizNotice.error(nextProps.save.msg)
    }
  }

  render() {
    const columns = [
      {
        title: '资源帐号类型',
        name: 'type',
        dataIndex: 'type',
        formItem: {
          type: 'select',
          rules: [{ required: true, message: '请选择资源帐号类型' }],
        },
        dict: [
          {code: 1, codeName: '远程评估 '},
          {code: 2, codeName: '直播课堂/远程认证'}
        ]
      },
      {
        title: "用户付费类型",
        name: "userType",
        dataIndex: "userType",
        formItem: {
          type: 'select',
          rules: [{ required: true, message: '请选择用户付费类型' }],
        },
        dict: [
          {code: 1, codeName: '免费用户'},
          {code: 2, codeName: '授权用户'},
          {code: 3, codeName: '预置用户'},
        ]
      },
      {
        title: "创建资源数",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol span={10}>
                  {
                    getFieldDecorator('resourcesCount', {
                      rules: [{required: true, message: '请输入创建资源数'}],
                      initialValue:1,
                    })(
                      <WizInputNumber maxlength={2} min={1} max={50}
                                      placeholder="请输入创建资源数"/>
                    )
                  }
                </WizCol>
                <WizCol span={2}>
                  <WizTooltip title={'请合理创建资源账号数，数量请参考中目后台用户管理处限制添加相应类型账号数'}>
                    <WizIcon type='question-circle-o' style={{marginLeft: 20}}/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: "账号到期时间",
        name: "expirationTime",
        dataIndex: "expirationTime",
        formItem: {
          type: 'date',
          initialValue:  null,
        }
      },
    ]

    const formProps = {
      key: this.state.timestamp,
      ref: 'form',
      columns,
      record:{},
      preview: false,
      onSubmit: this._ok,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      }
    }

    return <WizForm {...formProps} />
  }
}
const mapStateToProps = (state, ownProps) => {
  const { interactLiveResources } = state
  const save = modelUtils.getModelEntity(interactLiveResources, 'interactLiveResources@batchCreateZoomUserResources')
  return {
    save
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Editor)
